<template>
    <BreadCrumb PageTitle="Modification de produit" />
    <EditProduit />
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EditProduit from "../../components/Produit/EditProduit.vue";

    export default defineComponent({
        name: "EditProduitPage",
        components: {
            BreadCrumb,
            EditProduit,
        },
    });
</script>